import request from '@/plugins/request'

export function login(username, password) {
    return request({
        url: '/v1/Login/UserLogin',
        method: 'post',
        data: {
            userName: username,
            password: password,
        }
    })
}

export function register(username,userphone, password, repassword) {
    return request({
        url: '/v1/Login/UserRegister',
        method: 'post',
        data: {
            userName: username,
            userphone: userphone,
            password: password,
            rePassword: repassword,
        }
    })
}

export function tokenrefresh() {
    return request({
        url: '/v1/Login/TokenRefresh',
        method: 'post',
    })
}

export function getInfo() {
    return request({
        url: '/v1/Login/GetUserInfo',
        method: 'post'
    })
}

export function logout() {
    return request({
        url: '/v1/Login/UserLogout',
        method: 'post'
    })
}

